export default __webpack_public_path__ + "static/m-customer5-974c3757ad94ab0aebcb95d01ea30ec0.png";